import { Link } from 'react-router-dom';

const footerLinks = {
  content: {
    title: '内容分类',
    links: [
      { to: '/category/japan-drama', label: '日剧' },
      { to: '/category/korea-drama', label: '韩剧' },
      { to: '/category/japan-movie', label: '日本电影' },
      { to: '/category/korea-movie', label: '韩国电影' },
      { to: '/category/kpop', label: 'K-POP' },
      { to: '/category/jpop', label: 'J-POP' },
      { to: '/category/variety', label: '日韩综艺' },
      { to: '/category/star', label: '明星动态' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { to: '/about', label: '品牌介绍' },
      { to: '/about', label: '联系我们' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="text-xl font-heading font-bold text-foreground-950 tracking-wide">
                aaa一级日韩
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              最新最全的日本韩国影视娱乐资讯平台。每日更新日剧韩剧推荐、K-POP与J-POP音乐、综艺节目与明星动态。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">
              {footerLinks.content.title}
            </h4>
            <ul className="space-y-2">
              {footerLinks.content.links.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">
              {footerLinks.about.title}
            </h4>
            <ul className="space-y-2">
              {footerLinks.about.links.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">关注我们</h4>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-200 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-200 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-200 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors duration-200 cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-200 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors duration-200 cursor-pointer" aria-label="小红书">
                <i className="ri-reddit-line"></i>
              </a>
            </div>
            <p className="mt-4 text-xs text-foreground-500">
              合作联系：contact@aaa-rikhan.com
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 aaa一级日韩. 本站内容仅供娱乐资讯参考。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200 cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200 cursor-pointer">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}